import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Shimmer from "components/ui/shimmer"
import { cn } from "styles/utils"

const SaleBadge = ({ sale = false, ...props }) => (
  <div
    className={cn(
      "bg-ruby text-12 tablet:text-14 tablet:leading-16 tablet:px-8 leading-14 inline-flex items-center justify-center px-4 py-4 font-bold uppercase tracking-wide text-white",
      sale ? "rounded-md" : "rounded-xs"
    )}
    {...props}
  />
)

SaleBadge.propTypes = {
  mobileSimplifyVariantExp: PropTypes.bool,
  sale: PropTypes.bool,
}

const Badge = () => {
  const { pricing, priorityBadge, wizardLoading } = useSelector((state) => ({
    // holidayDelivery: state.wizard.shipping?.main?.available_holiday_delivery,
    pricing: state.wizard.price_and_promo,
    priorityBadge: state.wizard.priorityBadge,
    wizardLoading: state.wizard.loading,
  }))

  if (wizardLoading || !Object.keys(pricing).length) {
    return (
      <Shimmer className="mb-10" style={{ height: "24px", width: "120px" }} />
    )
  }

  if (priorityBadge) {
    return (
      <SaleBadge sale>
        <FontAwesomeIcon
          className="text-8 tablet:text-16 mr-6 text-white"
          icon={faTag}
        />
        {priorityBadge.label}
      </SaleBadge>
    )
    // } else if (holidayDelivery) {
    //   return (
    //     <SaleBadge sale>
    //       {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}{" "}
    //       Delivery
    //     </SaleBadge>
    //   )
  } else if (pricing.on_sale) {
    const percentageSavings = (
      ((pricing.regular_pricing - pricing.price_to_display) * 100) /
      pricing.regular_pricing
    ).toFixed(0)

    return <SaleBadge>SAVE {percentageSavings}% OFF</SaleBadge>

    // return <SaleBadge>SALE</SaleBadge>
  } else return null
}

export default Badge
